import { memo, useEffect, useState } from 'react';

import DoughnutChart from 'components/ui/charts/DoughnutChart';
import { useTranslation } from 'react-i18next';
import moment from 'moment';

function getStatusColors(status) {
  const colors = {
    Damda: 'rgb(54, 162, 235)', // Ko'k (oldin Kelgan rangi edi)
    Kechikkan: 'rgb(251, 190, 35)', // Sariq (o'zgarmadi)
    Kelgan: 'rgb(75, 192, 192)', // Yashil (oldin Damda rangi edi)
    Kelmagan: 'rgb(255, 99, 132)', // Qizil (o'zgarmadi)
  };

  return colors[status];
}

export default memo(function Widget({ data: widget, stats, onFilterStatus }) {
  const { t } = useTranslation();
  const [data, setData] = useState([]);
  const [labels, setLabels] = useState([]);
  const [values, setValues] = useState([]);
  const [colors, setColors] = useState([]);
  const [total, setTotal] = useState(0);

  useEffect(() => {
    if (stats) {
      const labels = Object?.keys(stats);
      const values = Object?.values(stats);
      const colors = Object?.keys(stats)?.map((s) => getStatusColors(s));

      setData(
        Object?.entries(stats)
          ?.map(([name, value], i) => ({
            name: name,
            value: value,
            color: getStatusColors(name),
          }))
          ?.sort((a, b) => b.value - a.value),
      );
      setTotal(values?.reduce((sum, d) => sum + d, 0));
      setLabels(labels);
      setValues(values);
      setColors(colors);
    }
  }, [widget]);

  return (
    <div className='bg-white mb-4 rounded-lg h-full'>
      <div className=''>
        <div className='flex items-center justify-center rounded-t-lg py-4 bg-gray-50 mb-2'>
          <h2>
            {widget?.date
              ? moment(widget?.date, 'YYYY-MM-DD').format('DD.MM.YYYY')
              : ''}
          </h2>
        </div>

        <div className={'flex gap-4 flex-col items-center py-[24px] px-[32px]'}>
          <div className='relative h-64 w-64 min-w-64'>
            <DoughnutChart
              chartLabels={labels}
              chartDatasets={[
                {
                  data: values,
                  backgroundColor: colors,
                  borderWidth: 2,
                  hoverOffset: 15,
                  hoverBorderWidth: 0,
                  borderRadius: 4,
                },
              ]}
              suffix=''
              optionPlugins={{
                legend: {
                  display: false,
                },
              }}
              options={{
                layout: {
                  padding: {
                    top: 10,
                    bottom: 10,
                  },
                },
              }}
            />
            {/* {totalTask > 0 && ( */}
            <div className='text-center absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2'>
              <h1 className='text-[35px]'>{total.toLocaleString()}</h1>
              <p className='text-sm text-gray-500'>{t('common.table.total')}</p>
            </div>
            {/* )} */}
          </div>
          {/* <div className='max-h-[50vh] my-scroll overflow-y-auto'> */}
          <div className='text-sm flex overflow-x-auto my-scroll w-full max-h-[500px]'>
            {data?.map((item, i) => (
              <div
                key={`${i}hodimlar`}
                className='flex flex-col items-center justify-between gap-2 text-[16px] font-medium text-[#464255] w-full py-3 px-2 my-1.5 cursor-pointer hover:bg-gray-50 rounded-lg'
                onClick={() => onFilterStatus(item?.name)}
              >
                <div
                  className='flex items-center whitespace-nowrap'
                  style={{ color: item?.color }}
                >
                  {item?.name}
                </div>
                <div
                  className='flex items-center whitespace-nowrap'
                  style={{ color: item?.color }}
                >
                  {item?.value?.toLocaleString()}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
});
